import { useState, useRef, useEffect } from 'react';
import { VideoElement } from '../../types/player';

export const usePlayerState = (videoElement: VideoElement) => {
  const [isInitialized, setIsInitialized] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isBuffering, setIsBuffering] = useState(false);

  const autoPlayAttemptedRef = useRef(false);

  // Initialize player state when video element changes
  useEffect(() => {
    if (!videoElement) return;

    setIsInitialized(false);
    autoPlayAttemptedRef.current = false;

    // Initialize with current video state if available
    if (!isNaN(videoElement.duration) && isFinite(videoElement.duration)) {
      setDuration(videoElement.duration);
      setCurrentTime(videoElement.currentTime);
      setIsPlaying(!videoElement.paused);
      setIsInitialized(true);
    }
  }, [videoElement]);

  const resetPlayerState = () => {
    setIsInitialized(false);
    setIsPlaying(false);
    setCurrentTime(0);
    setDuration(0);
    setIsBuffering(false);
    autoPlayAttemptedRef.current = false;
  };

  return {
    isInitialized,
    setIsInitialized,
    isPlaying,
    setIsPlaying,
    currentTime,
    setCurrentTime,
    duration,
    setDuration,
    isBuffering,
    setIsBuffering,
    autoPlayAttemptedRef,
    resetPlayerState,
  };
};
